import { MENTAL_ORG } from "./orgIds.js";

export const DEFAULT_FATIGUE_LIMIT = 10;
export const MENTAL_FATIGUE_LIMIT = 12;

export function fatigueLimit(organizations: readonly string[]): number {
  return organizations.includes(MENTAL_ORG) ? MENTAL_FATIGUE_LIMIT : DEFAULT_FATIGUE_LIMIT;
}
